//
// Autogenerated by Thrift Compiler (0.13.0)
//
// DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
//
"use strict";

var thrift = require("thrift");
var Thrift = thrift.Thrift;
var Q = thrift.Q;
var Int64 = require("node-int64");

var ttypes = (module.exports = {});
var UserRecoveryKeyMetadata = (module.exports.UserRecoveryKeyMetadata =
  function (args) {
    this.recoveryKey = null;
    this.recoveryKeyId = null;
    if (args) {
      if (args.recoveryKey !== undefined && args.recoveryKey !== null) {
        this.recoveryKey = args.recoveryKey;
      } else {
        throw new Thrift.TProtocolException(
          Thrift.TProtocolExceptionType.UNKNOWN,
          "Required field recoveryKey is unset!",
        );
      }
      if (args.recoveryKeyId !== undefined && args.recoveryKeyId !== null) {
        this.recoveryKeyId = args.recoveryKeyId;
      } else {
        throw new Thrift.TProtocolException(
          Thrift.TProtocolExceptionType.UNKNOWN,
          "Required field recoveryKeyId is unset!",
        );
      }
    }
  });
UserRecoveryKeyMetadata.prototype = {};
UserRecoveryKeyMetadata.prototype.read = function (input) {
  input.readStructBegin();

  while (true) {
    var ret = input.readFieldBegin();
    var ftype = ret.ftype;
    var fid = ret.fid;

    if (ftype == Thrift.Type.STOP) {
      break;
    }

    switch (fid) {
      case 1:
        if (ftype == Thrift.Type.STRING) {
          this.recoveryKey = input.readString();
        } else {
          input.skip(ftype);
        }
        break;
      case 2:
        if (ftype == Thrift.Type.I64) {
          this.recoveryKeyId = input.readI64();
        } else {
          input.skip(ftype);
        }
        break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

UserRecoveryKeyMetadata.prototype.write = function (output) {
  output.writeStructBegin("UserRecoveryKeyMetadata");
  if (this.recoveryKey !== null && this.recoveryKey !== undefined) {
    output.writeFieldBegin("recoveryKey", Thrift.Type.STRING, 1);
    output.writeString(this.recoveryKey);
    output.writeFieldEnd();
  }
  if (this.recoveryKeyId !== null && this.recoveryKeyId !== undefined) {
    output.writeFieldBegin("recoveryKeyId", Thrift.Type.I64, 2);
    output.writeI64(this.recoveryKeyId);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};
